import { useXGScale } from '@statsbomb/kitbag-datavis';
import { useAtomValue } from 'jotai';
import { pitchMarkerColouringModeAtom } from '@/atoms/visualisation';
import { MARKER_HIGHLIGHTED_COLOUR } from '@/consts/markerColours';
import { EventSuccessFail, MarkerEvent } from '@/types/event';
import { isNullish } from '@/utils/predicates';
import { useObvScale } from '../useObvScale';
import { useSuccessFailColouring } from '../useSuccessFailColouring';

export const useEventMarkerColour = (currentlySelectedVideoId: string | null) => {
  const pitchMarkerColouringMode = useAtomValue(pitchMarkerColouringModeAtom);

  const successFailColouring = useSuccessFailColouring();
  const xgScale = useXGScale();
  const obvScale = useObvScale();

  const getMarkerColour = (
    videoEventId: string | undefined,
    successFail: EventSuccessFail,
    xg: MarkerEvent['xg'],
    obv: MarkerEvent['obv'],
  ) => {
    if (pitchMarkerColouringMode === 'none') {
      return videoEventId === currentlySelectedVideoId ? MARKER_HIGHLIGHTED_COLOUR : undefined;
    }

    if (pitchMarkerColouringMode === 'xg') {
      return isNullish(xg) ? successFailColouring.neutral : xgScale(xg);
    }

    if (pitchMarkerColouringMode === 'obv') {
      return isNullish(obv) ? successFailColouring.neutral : obvScale(obv);
    }

    return successFailColouring[successFail];
  };

  return getMarkerColour;
};
